<label for="{{ name }}">{{ label }}</label>
<span>
  @if (!disabled) {
    <input
      name="{{ name }}"
      type="date"
      [(ngModel)]="dateObject.date"
      (change)="updateDate($event)" />
  }
  <ng-container
    *ngTemplateOutlet="
      !!disabled ? valueSpan : nothing;
      context: { value: dateObject.date | date: 'MM/dd/yyyy' }
    ">
  </ng-container>
</span>
<ng-template let-value="value" #valueSpan>
  @if (value?.length) {
    <span class="value">{{ value }}</span>
  } @else {
    <span class="value">&mdash;</span>
  }
</ng-template>
<ng-template #nothing></ng-template>
